import Color from '../Color.mjs'
import superMeta from '../_PRODUCT/metaProductNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.LIGHT_ORANGE,
    codeProp: 'isrfNo',
    detailUrl: '/IsrfDetail',
    detailIdProp: 'isrfId',
    mapProp: 'isrfMap',
    name: '软件SPEC单',
    textProp: 'isrfName',
    type: 'ISRF',
}
